export const SVG_NS = 'http://www.w3.org/2000/svg';

type Attrs = Record<string, string | number | boolean | null | undefined>;

/** SVG element with attributes, appended to parent when given. */
export function svg<K extends keyof SVGElementTagNameMap>(tag: K, attrs: Attrs = {}, parent?: Element): SVGElementTagNameMap[K] {
  const e = document.createElementNS(SVG_NS, tag);
  for (const [k, v] of Object.entries(attrs)) if (v !== null && v !== undefined && v !== false) e.setAttribute(k, String(v));
  if (parent) parent.appendChild(e);
  return e;
}

/** HTML element with attributes and children. Text children are set with textContent semantics. */
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: (Node | string | null | undefined | false)[]): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === null || v === undefined || v === false) continue;
    if (k === 'class') e.className = String(v);
    else e.setAttribute(k, String(v));
  }
  for (const c of children) if (c !== null && c !== undefined && c !== false) e.append(c);
  return e;
}

export function svgText(parent: Element, x: number, y: number, text: string, cls: string, size: number, anchor = 'middle', extra: Attrs = {}): SVGTextElement {
  const t = svg('text', { x: x.toFixed(2), y: y.toFixed(2), class: cls, 'font-size': size.toFixed(2), 'text-anchor': anchor, ...extra }, parent);
  t.textContent = text;
  return t;
}
